<template>
  <div v-if="$route.name == 'dmeApprove'">
    <router-view></router-view>
    <Toast></Toast>
  </div>
  <div v-else>
    <ConfirmDialog />
    <Loading :active="state.isLoading" :is-full-page="true"> </Loading>
    <MainMenu v-if="state.token"></MainMenu>
    <router-view />
    <Toast></Toast>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import usePlugin from "./plugins";
import { useToast } from "primevue/usetoast";
import useState from "./store";
import { useConfirm } from "primevue/useconfirm";
import Loading from "vue3-loading-overlay";
import MainMenu from "@/components/MainMenu.vue";
import ConfirmDialog from "primevue/confirmdialog";
import { GetProfileResponse } from "./types";

export default defineComponent({
  components: { Loading, MainMenu, ConfirmDialog },
  setup() {
    const state = useState();
    const { setupComponent } = usePlugin();

    const { queryProfile } = usePlugin();
    onMounted(() => {
      const toast = useToast();
      const confirm = useConfirm();
      setupComponent(toast, confirm);

      queryProfile();
    });

    return { state };
  },
});
</script>

<style>
body {
  margin: 0;
  font-size: 0.9rem;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
</style>
